module.exports = __webpack_public_path__ + "img/biscolala.fb894ad3.jpeg";